import React from 'react';
import { Modal, FormGroup, Row, Col, Button } from 'react-bootstrap';
import { Label } from 'fw/components';
import { Form, IntBox } from 'fw/forms';

// NVBDC-1404 — pencil-icon popup, local-state-only (see CapabilitiesPopUp.js for the pattern note).
class EmployeesPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState(props);
    }

    initialState = (props) => {
        return {
            visible: props.visible,
            form: {
                amountFullTimeEmployee: props.amountFullTimeEmployee || null,
                amountVeteranEmployee: props.amountVeteranEmployee || null,
                amountPartTimeEmployee: props.amountPartTimeEmployee || null,
                amountContractor: props.amountContractor || null
            }
        };
    };

    componentWillReceiveProps(nextProps) {
        this.setState({
            visible: nextProps.visible,
            form: {
                amountFullTimeEmployee: nextProps.amountFullTimeEmployee || null,
                amountVeteranEmployee: nextProps.amountVeteranEmployee || null,
                amountPartTimeEmployee: nextProps.amountPartTimeEmployee || null,
                amountContractor: nextProps.amountContractor || null
            }
        });
    }

    onChange = (form) => {
        this.setState({ form });
    };

    save = () => {
        this.props.onSave(this.state.form);
        this.close();
    };

    close = () => {
        this.setState({ visible: false }, () => this.props.onClose());
    };

    render() {
        return (
            <Modal show={this.state.visible} onHide={this.close}>
                <Modal.Header>
                    <h3>Company Employees and 1099s</h3>
                </Modal.Header>
                <Modal.Body>
                    <Form onChange={this.onChange} values={this.state.form} ref={(form) => { this._form = form; }}>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="amountFullTimeEmployee" required>Number of Full-time employees</Label>
                                    <IntBox name="amountFullTimeEmployee" placeholder="# Full-Time" maxLength={9} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="amountVeteranEmployee" required>Number of Veteran employees</Label>
                                    <IntBox name="amountVeteranEmployee" placeholder="# Veteran" maxLength={9} />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="amountPartTimeEmployee" required>Number of Part-time employees</Label>
                                    <IntBox name="amountPartTimeEmployee" placeholder="# Part-Time" maxLength={9} />
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                    <Label htmlFor="amountContractor" required>Number of 1099 Recipients</Label>
                                    <IntBox name="amountContractor" placeholder="# Contractor/1099" maxLength={9} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button id="btnSaveEmployees" bsStyle="success" onClick={this.save}>Save</Button>
                    <Button id="btnCloseEmployees" onClick={this.close}>Close</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default EmployeesPopUp;



// WEBPACK FOOTER //
// ./src/areas/certification/oneSheet/popups/EmployeesPopUp.js